export const PUBLIC_USER_DATA_API = '/api/user/user-data'

export const DASHBOARD_USER_DATA_API = '/api/dashboard/user/user-data'
